import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import AxiosUtil from '../../Utils/AxiosUtil';
import {
    Alert as ServaAlert,
    AlignCenterOutlinedIcon,
    Button,
    Col,
    Divider,
    EditIcon,
    FontColorsOutlinedIcon,
    Input,
    Modal as ServaModal,
    Option,
    Row,
    VisibilityIcon,
    Select,
    ShrinkOutlinedIcon,
    Space,
    Spin,
    Text,
    Title,
    Tooltip,
} from '@servahealth/serva-ui-kit';
import { ReactComponent as HtmlIcon } from '../../Images/code-slash.svg';
import StopOutlinedIcon from '../Icons/StopOutlinedIcon';
import DataSetColumnFormatModel from '../../Interfaces/Responses/Reports/DataSets/DatasetColumnFormatModel';
import Dashboard from '../../Constants/Endpoints/Dashboard';
import ResetCustomizationForReportItemByCurrentToken from '../../Interfaces/Requests/Dashboard/ResetCustomizationForReportItemByCurrentToken';
import UpdateCustomizationForReportItemByCurrentToken from '../../Interfaces/Requests/Dashboard/UpdateCustomizationForReportItemByCurrentToken';
import ReportCustomizationsFormat from './ReportCustomizationsFormat';
import { StringUtil } from '../../Utils/StringUtil';

type ReportCustomizationsProps = {
    currentToken?: string;
    dataSetColumnFormatModels: DataSetColumnFormatModel[];
    name: string;
    reportId?: number;
    reportItemId?: number;
    close: () => void;
};

const ReportCustomizations: React.FC<ReportCustomizationsProps> = ({
    currentToken,
    dataSetColumnFormatModels,
    name,
    reportId,
    reportItemId,
    close,
}) => {
    const [customName, setCustomName] = useState(name);
    const [customizations, setCustomizations] = useState<UpdateCustomizationForReportItemByCurrentToken[]>([]);
    const [changeOccurred, setChangeOccurred] = useState(false);
    const [dataSetColumnTitleEditOpen, setDataSetColumnTitleEditOpen] = useState(false);
    const [dataSetColumnFormatEditOpen, setDataSetColumnFormatEditOpen] = useState(false);
    const [columnFormats, setColumnFormats] = useState<DataSetColumnFormatModel[]>(dataSetColumnFormatModels);
    const [activeDataSetColumnFormatOrTitle, setActiveDataSetColumnFormatOrTitle] = useState<DataSetColumnFormatModel>();

    const [currentError, setCurrentError] = useState('');

    useEffect(() => {
        if (dataSetColumnFormatModels.length > 0) {
            setColumnFormats(dataSetColumnFormatModels);
        }
    }, [dataSetColumnFormatModels]);

    const getNewCustomization = (
        column: string,
        type: string,
        valueStr: string,
        value: number
    ): UpdateCustomizationForReportItemByCurrentToken => {
        return {
            currentToken: currentToken,
            reportItemID: reportItemId ?? 0,
            column: column,
            type: type,
            valueStr: valueStr,
            value: value,
        };
    };

    const handleReportItemTitleChange = (e: any) => {
        setChangeOccurred(true);

        setCustomName(e.target.value);

        let newCustomization = undefined;

        newCustomization = getNewCustomization('', 'title', e.target.value, -1);
        setCustomizations([...customizations, newCustomization]);
    };

    const handleChange = (e: string, columnName: string, typeOfChange: string) => {
        setChangeOccurred(true);

        let index = columnFormats.findIndex((item) => item.columnName === columnName);

        const updatedColumnFormats = [...columnFormats];
        const updatedColumnFormat = updatedColumnFormats[index];

        if (typeOfChange === 'aggregate') {
            updatedColumnFormat.aggregate = e;
        }
        else if (typeOfChange === 'alignment') {
            updatedColumnFormat.alignment = e;
        }
        else if (typeOfChange === 'allowHtml') {
            updatedColumnFormat.allowHtml = e === 'HTML';
        }
        else if (typeOfChange === 'columnTitle') {
            updatedColumnFormat.columnTitle = e;
        }
        else if (typeOfChange === 'format') {
            updatedColumnFormat.format = e;
        }
        else if (typeOfChange === 'visibility') {
            updatedColumnFormat.hide = e === 'Hidden';
        }

        updatedColumnFormats[index] = updatedColumnFormat;
        setColumnFormats(updatedColumnFormats);

        /*
        index = customizations.findIndex((item) => item.column === columnName || (typeOfChange === 'title' && item.type === 'title'));

        if (index === -1) {
            let newCustomization = undefined;

            if (typeOfChange === 'aggregate') {
                newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
                setCustomizations([...customizations, newCustomization]);
            }
            else if (typeOfChange === 'alignment') {
                newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
                setCustomizations([...customizations, newCustomization]);
            }
            else if (typeOfChange === 'allowHtml') {
                newCustomization = getNewCustomization(columnName, typeOfChange, '', e === 'HTML' ? 1 : 0);
                setCustomizations([...customizations, newCustomization]);
            }
            else if (typeOfChange === 'columnTitle') {
                newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
                setCustomizations([...customizations, newCustomization]);
            }
            else if (typeOfChange === 'format') {
                newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
                setCustomizations([...customizations, newCustomization]);
            }
            else if (typeOfChange === 'visibility') {
                newCustomization = getNewCustomization(columnName, typeOfChange, '', e === 'Hidden' ? 0 : 1);
                setCustomizations([...customizations, newCustomization]);
            }
        } else {
            const updatedCustomizations = [...customizations];
            const updatedCustomization = updatedCustomizations[index];

            if (typeOfChange === 'allowHtml') {
                updatedCustomization.value = e === 'HTML' ? 0 : 1;
            } else if (typeOfChange === 'visibility') {
                updatedCustomization.value = e === 'Hidden' ? 0 : 1;
            } else {
                updatedCustomization.valueStr = e;
            }

            updatedCustomizations[index] = updatedCustomization;
            setCustomizations(updatedCustomizations);
        */
        //--NEW

        let newCustomization = undefined;

        if (typeOfChange === 'aggregate') {
            newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
            setCustomizations([...customizations, newCustomization]);
        }
        else if (typeOfChange === 'alignment') {
            newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
            setCustomizations([...customizations, newCustomization]);
        }
        else if (typeOfChange === 'allowHtml') {
            newCustomization = getNewCustomization(columnName, typeOfChange, '', e === 'HTML' ? 1 : 0);
            setCustomizations([...customizations, newCustomization]);
        }
        else if (typeOfChange === 'columnTitle') {
            newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
            setCustomizations([...customizations, newCustomization]);
        }
        else if (typeOfChange === 'format') {
            newCustomization = getNewCustomization(columnName, typeOfChange, e, 0);
            setCustomizations([...customizations, newCustomization]);
        }
        else if (typeOfChange === 'visibility') {
            newCustomization = getNewCustomization(columnName, typeOfChange, '', e === 'Hidden' ? 0 : 1);
            setCustomizations([...customizations, newCustomization]);
        }

        //--END NEW
    };

    const handleAggregateChange = (e: string, dataSetColumnFormatModel: DataSetColumnFormatModel) => {
        handleChange(e, dataSetColumnFormatModel.columnName, 'aggregate');
    };

    const handleAlignmentChange = (e: string, dataSetColumnFormatModel: DataSetColumnFormatModel) => {
        handleChange(e, dataSetColumnFormatModel.columnName, 'alignment');
    };

    const handleAllowHtmlChange = (e: string, dataSetColumnFormatModel: DataSetColumnFormatModel) => {
        handleChange(e, dataSetColumnFormatModel.columnName, 'allowHtml');
    };

    const handleColumnTitleChange = (columnTitle: string | undefined) => {
        handleChange(columnTitle ?? '', activeDataSetColumnFormatOrTitle?.columnName ?? '', 'columnTitle');
    };

    const handleColumnFormatChange = (format: string | undefined) => {
        handleChange(format ?? '', activeDataSetColumnFormatOrTitle?.columnName ?? '', 'format');
    };

    const handleVisibilityChange = (e: string, dataSetColumnFormatModel: DataSetColumnFormatModel) => {
        handleChange(e, dataSetColumnFormatModel.columnName, 'visibility');
    };

    const handleColumnFormatOrTitleChange = (typeOfChange: string, dataSetColumnName: string | undefined) => {
        let index = columnFormats.findIndex((item) => item.columnName === dataSetColumnName);
        const existingColumnFormats = [...columnFormats];

        setActiveDataSetColumnFormatOrTitle(existingColumnFormats[index]);

        if (typeOfChange === 'format') {
            if (existingColumnFormats[index]?.jsDataType === 'date' || existingColumnFormats[index]?.jsDataType === 'number') {
                setDataSetColumnFormatEditOpen(true);
            }
        }
        else {
            setDataSetColumnTitleEditOpen(true);
        }

        /*if (existingColumnFormats[index]?.jsDataType === 'date' || existingColumnFormats[index]?.jsDataType === 'number') {
            setActiveDataSetColumnFormat(existingColumnFormats[index]);
            setDataSetColumnFormatEditOpen(true);
        }
        else {
            setActiveDataSetColumnTitle(existingColumnFormats[index]);
            setDataSetColumnTitleEditOpen(true);
        }*/
    };

    const { mutate: addReportItemCustomizations, isLoading: isAddReportItemCustomizationsLoading, isError: isAddReportItemCustomizationsError, error: getAddReportItemCustomizationsError, } = useMutation(
        async () => {
            try {
                const url = `${process.env.REACT_APP_API_ROOT}${Dashboard.UPDATE_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN}`;
                const responseData = await AxiosUtil.post<boolean, UpdateCustomizationForReportItemByCurrentToken[]>(url, customizations);
                return responseData;
            } catch (err) {
                setCurrentError('ADD_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN: [Add Report Item Customizations] Internal Error: ' + err);
                console.error('ADD_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN: [Add Report Item Customizations] Internal Error: ', err);
                return Promise.reject();
            }
        },
        {
            onError: (err: any) => {
                setCurrentError('ADD_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN: [Add Report Item Customizations] Internal Error: ' + err);
                console.error('ADD_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN [Add Report Item Customizations] Internal Error: ', err);
                ServaModal.error({
                    title: 'Report Customizations',
                    content: `Report customizations for ${reportId} were unable to be saved. Please contact application support.`,
                });
            },
            onSuccess: (response: boolean) => {
                ServaModal.success({
                    title: 'Report Customizations',
                    content: `Report customizations for ${reportId} were saved successfully.`,
                });
                close();
            },
        }
    );

    const { mutate: removeAllReportItemCustomizations, isLoading: isRemoveAllReportItemCustomizationsLoading, isError: isRemoveAllReportItemCustomizationsError, error: getRemoveAllReportItemCustomizationsError, } = useMutation(
        async () => {
            try {
                const url = `${process.env.REACT_APP_API_ROOT}${Dashboard.RESET_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN}`;
                const requestData: ResetCustomizationForReportItemByCurrentToken = { currentToken: currentToken, reportItemID: reportItemId ?? 0, };
                const responseData = await AxiosUtil.post<boolean, ResetCustomizationForReportItemByCurrentToken>(url, requestData);
                return responseData;
            } catch (err) {
                setCurrentError('RESET_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN: [Remove Report Item Customizations] Internal Error: ' + err);
                console.error('RESET_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN: [Remove Report Item Customizations] Internal Error: ', err);
                return Promise.reject();
            }
        },
        {
            onError: (err: any) => {
                setCurrentError('RESET_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN: [Remove Report Item Customizations] Internal Error: ' + err);
                console.error('RESET_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN [Remove Report Item Customizations] Internal Error: ', err);
                ServaModal.error({
                    title: 'Reset Report Customizations',
                    content: `Report customizations for ${reportId} were unable to be reset. Please contact application support.`,
                });
            },
            onSuccess: (response: boolean) => {
                ServaModal.success({
                    title: 'Reset Report Customizations',
                    content: `Report customizations for ${reportId} were reset successfully.`,
                });
                close();
            },
        }
    );

    const determineWhichError = () => {
        if ( isAddReportItemCustomizationsError ) {
            return currentError + ' ' + (getAddReportItemCustomizationsError as any).response?.data.message;
        }
        else if ( isRemoveAllReportItemCustomizationsError ) {
            return currentError + ' ' + (getRemoveAllReportItemCustomizationsError as any).response?.data.message;
        }
        else {
            return '';
        }
    } 

    return (
        <>
            <ServaModal
                destroyOnHidden={true}
                hideButtons={true}
                open={dataSetColumnTitleEditOpen}
                width={'500px'}
                onCancel={() => setDataSetColumnTitleEditOpen(false)}
            >
                <ReportCustomizationsFormat
                    dataSetColumnFormat={undefined}
                    dataSetColumnTitle={activeDataSetColumnFormatOrTitle}
                    updateDataSetColumnFormat={(format: string | undefined) => {}}
                    updateDataSetColumnTitle={handleColumnTitleChange}
                    close={() => setDataSetColumnTitleEditOpen(false)}
                ></ReportCustomizationsFormat>
            </ServaModal>
            <ServaModal
                destroyOnHidden={true}
                hideButtons={true}
                open={dataSetColumnFormatEditOpen}
                width={'500px'}
                onCancel={() => setDataSetColumnFormatEditOpen(false)}
            >
                <ReportCustomizationsFormat
                    dataSetColumnFormat={activeDataSetColumnFormatOrTitle}
                    dataSetColumnTitle={undefined}
                    updateDataSetColumnFormat={handleColumnFormatChange}
                    updateDataSetColumnTitle={(title: string | undefined) => {}}
                    close={() => setDataSetColumnFormatEditOpen(false)}
                ></ReportCustomizationsFormat>
            </ServaModal>
            <Spin spinning={
                            isAddReportItemCustomizationsLoading ||
                            isRemoveAllReportItemCustomizationsLoading
                           }>
                <div style={{ display: 'table', margin: 'auto', textAlign: 'center', width: '50%' }}>
                {
                    (
                        isAddReportItemCustomizationsError || isRemoveAllReportItemCustomizationsError
                    )
                    &&
                    (
                        <ServaAlert
                            className={'mb-2'}
                            message={determineWhichError()}
                            showIcon={true}
                            type="error"
                        ></ServaAlert>
                    )
                }
                </div>
                <Space direction='horizontal' style={{justifyContent: 'center', padding: '8px', width: '100%'}}>
                    <Text style={{height: '100%', width: '100%'}}>
                        <Title style={{backgroundColor: 'rgb(00, 55, 90)', borderRadius: '10px', color: 'white', height: '100%', padding: '8px', width: '100%'}} level={4}>Report Item Customization Options</Title>
                    </Text>
                </Space>
                <Row>
                    <Col span={6}>
                        <div style={{paddingTop:'8px', textAlign:'right'}}>
                            <Text italic strong type='secondary'>REPORT ITEM NAME:&nbsp;</Text>
                        </div>
                    </Col>
                    <Col span={15}>
                        <Input
                            value={customName}
                            onChange={handleReportItemTitleChange}
                        ></Input>
                    </Col>
                    <Col span={3}>
                        <div style={{paddingTop:'8px', textAlign:'right'}}>
                        </div>
                    </Col>
                </Row>
                <Divider></Divider>
                <Row>
                    <Col span={4}>
                        <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'left'}}>
                            <Text italic type='secondary'>COLUMN TITLE</Text>
                        </div>
                    </Col>
                    <Col span={3}>
                        <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                            <AlignCenterOutlinedIcon tooltipText='alignment'></AlignCenterOutlinedIcon>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                            <FontColorsOutlinedIcon tooltipText='format'></FontColorsOutlinedIcon>
                        </div>
                    </Col>
                    <Col span={3}>
                        <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                            <VisibilityIcon tooltipText='visibility'></VisibilityIcon>
                        </div>
                    </Col>
                    <Col span={3}>
                        <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                            <Tooltip title="allow html">
                                <HtmlIcon></HtmlIcon>
                            </Tooltip>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign: 'center'}}>
                            <ShrinkOutlinedIcon tooltipText='aggregate'></ShrinkOutlinedIcon>
                        </div>
                    </Col>
                    <Col span={3}>
                        <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign: 'center'}}>
                            <Text italic type='secondary'>Data Type</Text>
                        </div>
                    </Col>
                </Row>
                <Divider style={{ border: '1px solid lightgray', margin: '4px' }} />
                {
                    columnFormats.map((eachColumnFormat, index) => {
                        return (
                            <Row key={`${eachColumnFormat.columnName}-${index}`}>
                                <Col span={3}>
                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'left'}}>
                                        <label>{eachColumnFormat.columnTitle !== '' ? eachColumnFormat.columnTitle : eachColumnFormat.columnName}</label>
                                    </div>
                                </Col>
                                <Col span={1}>
                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                        <EditIcon
                                            onClick={() => handleColumnFormatOrTitleChange('columnTitle', eachColumnFormat.columnName)}
                                        ></EditIcon>
                                    </div>
                                </Col>
                                <Col span={3}>
                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                        <Select
                                            key={`AL-${index}`}
                                            style={{ width: '80%' }}
                                            value={StringUtil.CapitalizeFirstLetter(eachColumnFormat.alignment)}
                                            onChange={(e: any) => handleAlignmentChange(e, eachColumnFormat)}
                                        >
                                            <Option value="Left">Left</Option>
                                            <Option value="Center">Center</Option>
                                            <Option value="Right">Right</Option>
                                        </Select>
                                    </div>
                                </Col>
                                {
                                    <>
                                        {
                                            (eachColumnFormat.jsDataType === 'number') || (eachColumnFormat.jsDataType === 'date')
                                            ?
                                            (
                                                <Col span={3}>
                                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'left'}}>
                                                        <label>{eachColumnFormat.format}</label>
                                                    </div>
                                                </Col>
                                            )
                                            :
                                            (
                                                <Col span={3}>
                                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                                        <Text italic type='secondary'>N / A</Text>
                                                    </div>
                                                </Col>
                                            )
                                        }
                                    </>
                                }
                                {
                                    <>
                                        {
                                            (eachColumnFormat.jsDataType === 'number') || (eachColumnFormat.jsDataType === 'date')
                                            ?
                                            (
                                                <Col span={1}>
                                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                                        <EditIcon
                                                            onClick={() => handleColumnFormatOrTitleChange('format', eachColumnFormat.columnName)}
                                                        ></EditIcon>
                                                    </div>
                                                </Col>
                                            )
                                            :
                                            (
                                                <Col span={1}>
                                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                                        <StopOutlinedIcon></StopOutlinedIcon>
                                                    </div>
                                                </Col>
                                            )
                                        }
                                    </>
                                }
                                <Col span={3}>
                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                        <Select
                                            key={`VI-${index}`}
                                            style={{ width: '80%' }}
                                            value={eachColumnFormat.hide ? 'Hidden' : 'Visible'}
                                            onChange={(e: any) => handleVisibilityChange(e, eachColumnFormat)}
                                        >
                                            <Option value="Visible">Visible</Option>
                                            <Option value="Hidden">Hidden</Option>
                                        </Select>
                                    </div>
                                </Col>
                                <Col span={3}>
                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                        <Select
                                            key={`HT-${index}`}
                                            style={{ width: '80%' }}
                                            value={eachColumnFormat.allowHtml ? 'HTML' : 'Plain'}
                                            onChange={(e: any) => handleAllowHtmlChange(e, eachColumnFormat)}
                                        >
                                            <Option value="HTML">HTML</Option>
                                            <Option value="Plain">Plain</Option>
                                        </Select>
                                    </div>
                                </Col>
                                {
                                    <>
                                        {
                                            (eachColumnFormat.jsDataType === 'number')
                                            ?
                                            (
                                                <Col span={4}>
                                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                                        <Select
                                                            key={`AG-${index}`}
                                                            style={{ width: '80%' }}
                                                            value={eachColumnFormat.aggregate}
                                                            onChange={(e: any) => handleAggregateChange(e, eachColumnFormat)}
                                                        >
                                                            <Option value="">None</Option>
                                                            <Option value="AVG">Average</Option>
                                                            <Option value="COUNT">Count</Option>
                                                            <Option value="MAX">Maximum</Option>
                                                            <Option value="MIN">Minimum</Option>
                                                            <Option value="STDEV">Std. Dev.</Option>
                                                            <Option value="SUM">Summation</Option>
                                                            <Option value="VAR">Variance</Option>
                                                        </Select>
                                                    </div>
                                                </Col>
                                            )
                                            :
                                            (
                                                <Col span={4}>
                                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign:'center'}}>
                                                        <Text italic type='secondary'>N / A</Text>
                                                    </div>
                                                </Col>
                                            )
                                        }
                                    </>
                                }
                                <Col span={3}>
                                    <div style={{paddingTop: '0px', paddingBottom: '0px', textAlign: 'center'}}>
                                        <Text italic type='secondary'>{eachColumnFormat.jsDataType}</Text>
                                    </div>
                                </Col>
                            </Row>
                        );
                    })
                }
                <Divider></Divider>
                <Row>
                    <Col span={6} style={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            type='default'
                            onClick={() => removeAllReportItemCustomizations()}
                        >
                            Remove All Customizations
                        </Button>
                    </Col>
                    <Col span={12} />
                    <Col span={3} style={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            disabled={!changeOccurred}
                            htmlType="submit"
                            type="primary"
                            onClick={() => addReportItemCustomizations()}
                        >
                            Apply
                        </Button>
                    </Col>
                    <Col span={3} style={{display: 'flex', justifyContent: 'center'}}>
                        <Button type="default" onClick={() => close()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Spin>
        </>
    );
};

export default ReportCustomizations;
